<template>
<v-card flat>
    <v-card-title>
      <div>
        <h3 class="subheading">Quick reply</h3>
        <div class="caption grey--text">{{responsename}}</div>
      </div>
      <v-spacer></v-spacer> 
                <v-btn icon @click="cancelCard"><v-icon>clear</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-container grid-list-xl>
          <v-layout class="mt-0" row wrap>                       
            <v-flex class="mt-0" xs12>
              <!-- <v-select
                class="ma-0 pa-0"
                label="Select quick reply type"
                :items="replytypes"
                v-model="replytype"
                item-text="name"
                item-value="code"
              ></v-select> -->
              <v-textarea

                auto-grow
                v-model="title"
                label="Quick reply Name"                
                placeholder="Write the name here"
                counter="20"
                rows="1"
              ></v-textarea>
              <v-select

                class="ma-0 pa-0"
                label="link a response"
                :items="cresponses"
                item-text="name"
                return-object
                v-model="response"
              ></v-select>                                                     
            </v-flex>                        
            </v-layout>                  
        </v-container>
        <v-card-actions class="ma-0">
            <v-spacer></v-spacer>                  
                <v-btn round flat color="primary" @click="cancelCard">Cancel</v-btn>
                <v-btn round flat color="primary" @click="saveCard">Save</v-btn>                
        </v-card-actions>  
        </v-card>
</template>

<script>
export default {
  props:['editqreply'],
  data(){
    return{
      //title:null,
      //replytypes:[{"name":"User phone number","code":"user_phone_number"},{"name":"User email","code":"user_email"},{"name":"Send Location","code":"location"},{"name":"Link a Response","code":"text"}],
      replytypes:[{"name":"User phone number","code":"user_phone_number"},{"name":"User email","code":"user_email"},{"name":"Link a Response","code":"text"}],
      //replytype:null,
      responses:[],
      response:null
    }
  },
  methods:{
    saveCard(){
      let quickreply
      console.log(this.response)  
      // if(this.replytype == 'user_phone_number')
      // {
      //   quickreply = {"content_type":"user_phone_number"}  
      // }
      // else if (this.replytype == 'user_email')
      // {
      //   quickreply = {"content_type":"user_email"} 
      // }
      // else if (this.replytype == 'location')
      // {
      //   quickreply = {"content_type":"location"}
      // }
      // else if(this.replytype == 'text')
      // {
        quickreply =  {
                  "content_type":"text",
                  "title":this.title,
                  "payload":this.response.id
                }
      // }  
      let qrindex = this.qrindex        
      this.$store.dispatch('aSaveEditedquickreply', {quickreply, qrindex})
      let status = false
      this.$store.dispatch('aresponsemenuStatusChange',status)
    },
    cancelCard(){
      let status = false
      this.$store.dispatch('aresponsemenuStatusChange',status)
    },
    cusevent(){
      console.log("event triggered")

    }
  },
  computed:{
        cresponses(){
            return this.$store.state.responses
        },
        responsename(){
          let index = this.$store.state.currentResponseIndex
          let rname = this.$store.state.responses[index].name
          return rname   
        },
        replytype:{
          get:function(){
            return this.editqreply.replytype
          },
          set:function(newValue){
            return this.editqreply.replytype = newValue
          }          
        },
        title(){
          return this.editqreply.title
        },
        response(){
          return this.editqreply.response
        },
        qrindex(){
          return this.editqreply.qrindex
        },
        qreply(){
          return this.editqreply
        }
  }
}
</script>
